// extracted by mini-css-extract-plugin
export default {"chat":"chat_chat__fThst","chat-container":"chat_chat-container__Oicyo","chat-desc":"chat_chat-desc__sDDTr"};